/** @jsx jsx */
import { jsx } from 'theme-ui'
import { Container } from './container'

const CardText = ({ children }) => (
  <p
    sx={{
      fontWeight: 500,
      fontSize: 16,
      lineHeight: '150%',
      color: '#ADADAD'
    }}
  >
    {children}
  </p>
)

const content = [
  {
    icon: (
      <svg
        width="26"
        height="25"
        viewBox="0 0 26 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M15 6.5C15 10.0899 12.0899 13 8.5 13C4.91015 13 2 10.0899 2 6.5C2 2.91015 4.91015 0 8.5 0C12.0899 0 15 2.91015 15 6.5ZM13 6.5C13 8.98528 10.9853 11 8.5 11C6.01472 11 4 8.98528 4 6.5C4 4.01472 6.01472 2 8.5 2C10.9853 2 13 4.01472 13 6.5Z"
          fill="#F5F5F5"
        />
        <path
          d="M17.5 13C16.863 13 16.2473 12.9084 15.6656 12.7375C16.138 12.1953 16.5498 11.599 16.8906 10.9591C17.0899 10.9861 17.2933 11 17.5 11C19.9853 11 22 8.98528 22 6.5C22 4.01472 19.9853 2 17.5 2C17.2933 2 17.0899 2.01393 16.8906 2.04091C16.5498 1.40099 16.138 0.804663 15.6656 0.262453C16.2473 0.0916389 16.863 0 17.5 0C21.0899 0 24 2.91015 24 6.5C24 10.0899 21.0899 13 17.5 13Z"
          fill="#F5F5F5"
        />
        <path
          d="M0 20C0 17.2386 2.23858 15 5 15H12C14.7614 15 17 17.2386 17 20V25H15V20C15 18.3431 13.6569 17 12 17H5C3.34315 17 2 18.3431 2 20V25H0V20Z"
          fill="#F5F5F5"
        />
        <path
          d="M19 17H21C22.6569 17 24 18.3431 24 20V25H26V20C26 17.2386 23.7614 15 21 15H19V17Z"
          fill="#F5F5F5"
        />
      </svg>
    ),
    title: 'Public choice',
    content: (
      <div
        sx={{
          'p:last-child': {
            m: 0
          }
        }}
      >
        <CardText>
          It's important to us that real customers have their say in who wins.
        </CardText>
        <CardText>
          So, we've surveyed thousands of broadband, TV and mobile customers to
          find out what they think of their suppliers. Their responses will
          determine the winners of our public choice category awards.
        </CardText>
      </div>
    )
  },
  {
    icon: (
      <svg
        width="26"
        height="26"
        viewBox="0 0 26 26"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5 0H21V4H26V8C26 11.2028 23.4906 13.8194 20.3306 13.991C19.209 16.3608 16.7959 18 14 18V20H15C17.6124 20 19.8349 21.6696 20.6586 24C20.8797 24.6256 21 25.2987 21 26H5C5 25.2987 5.12031 24.6256 5.34141 24C6.16508 21.6696 8.38756 20 11 20H12V18C9.20408 18 6.79101 16.3608 5.66938 13.991C2.50944 13.8194 0 11.2028 0 8V4H5V0ZM12 16C9.23858 16 7 13.7614 7 11V2H19V11C19 13.7614 16.7614 16 14 16H12ZM2 6H5V11.874C3.27477 11.4299 2 9.86384 2 8V6ZM21 6V11.874C22.7252 11.4299 24 9.86384 24 8V6H21ZM11 22H15C16.4806 22 17.7733 22.8044 18.4649 24H7.53513C8.22675 22.8044 9.51944 22 11 22Z"
          fill="#F5F5F5"
        />
      </svg>
    ),
    title: 'Judges’ choice',
    content: (
      <div
        sx={{
          'p:last-child': {
            m: 0
          }
        }}
      >
        <CardText>
          We assembled an expert panel of leaders across consumer technology.
        </CardText>
        <CardText>
          Each judge will independently select their winners from the
          shortlisted networks and providers in our judges' choice categories.
        </CardText>
      </div>
    )
  },
  {
    icon: (
      <svg
        width="20"
        height="26"
        viewBox="0 0 20 26"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M6 10.5C6 11.3284 5.32843 12 4.5 12C3.67157 12 3 11.3284 3 10.5C3 9.67157 3.67157 9 4.5 9C5.32843 9 6 9.67157 6 10.5Z"
          fill="#F5F5F5"
        />
        <path
          d="M6 19.5C6 20.3284 5.32843 21 4.5 21C3.67157 21 3 20.3284 3 19.5C3 18.6716 3.67157 18 4.5 18C5.32843 18 6 18.6716 6 19.5Z"
          fill="#F5F5F5"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10 0C15.5228 0 20 1.79086 20 4V22C20 22.8519 19.4811 23.5044 18.9117 23.9531C18.331 24.4108 17.5528 24.7791 16.6802 25.07C14.9246 25.6552 12.5629 26 10 26C7.43715 26 5.07541 25.6552 3.31981 25.07C2.44724 24.7791 1.66896 24.4108 1.08829 23.9531C0.518893 23.5044 0 22.8519 0 22V4C0 1.79086 4.47715 0 10 0ZM17.8399 3.89613C17.8826 3.93647 17.9155 3.9711 17.9407 4C17.9155 4.0289 17.8826 4.06353 17.8399 4.10387C17.5788 4.3508 17.0937 4.66533 16.3283 4.97147C14.8086 5.57933 12.5721 6 10 6C7.42788 6 5.19136 5.57933 3.67171 4.97147C2.90634 4.66533 2.42118 4.3508 2.16007 4.10387C2.11741 4.06353 2.08451 4.0289 2.05929 4C2.08451 3.9711 2.11741 3.93647 2.16007 3.89613C2.42118 3.6492 2.90634 3.33467 3.67171 3.02853C5.19136 2.42067 7.42788 2 10 2C12.5721 2 14.8086 2.42067 16.3283 3.02853C17.0937 3.33467 17.5788 3.6492 17.8399 3.89613ZM18 6.40039V13.0002C18 13.0002 17.9999 13.0057 17.9969 13.0153C17.9935 13.0264 17.9852 13.0485 17.9649 13.0814C17.9225 13.1506 17.8359 13.2545 17.6738 13.3823C17.3436 13.6425 16.8038 13.9206 16.0477 14.1726C14.546 14.6732 12.4077 15 10 15C7.59229 15 5.45402 14.6732 3.95227 14.1726C3.19616 13.9206 2.65642 13.6425 2.32624 13.3823C2.16408 13.2545 2.07752 13.1506 2.03507 13.0814C2.01483 13.0485 2.00645 13.0264 2.00305 13.0153C1.99998 13.0052 2 13 2 13V6.40039C3.82446 7.37173 6.7288 8 10 8C13.2712 8 16.1755 7.37173 18 6.40039ZM18 22V15.5266C17.5988 15.7318 17.1533 15.9123 16.6802 16.07C14.9246 16.6552 12.5629 17 10 17C7.43715 17 5.07541 16.6552 3.31981 16.07C2.84666 15.9123 2.40123 15.7318 2 15.5266L2 22.0001C2 22.0001 1.99998 22.0052 2.00305 22.0153C2.00645 22.0264 2.01483 22.0485 2.03507 22.0814C2.07752 22.1506 2.16408 22.2545 2.32624 22.3823C2.65642 22.6425 3.19616 22.9206 3.95227 23.1726C5.45402 23.6732 7.59229 24 10 24C12.4077 24 14.546 23.6732 16.0477 23.1726C16.8038 22.9206 17.3436 22.6425 17.6738 22.3823C17.8359 22.2545 17.9225 22.1506 17.9649 22.0814C17.9852 22.0485 17.9935 22.0264 17.9969 22.0153C17.9979 22.012 17.9986 22.0094 17.9991 22.0072C17.9995 22.005 17.9999 22.0021 17.9999 22.0021L18 22Z"
          fill="#F5F5F5"
        />
      </svg>
    ),
    title: 'Uswitch data and other sources',
    content: (
      <div
        sx={{
          'p:last-child': {
            m: 0
          }
        }}
      >
        <CardText>
          For some categories, we look at insights from our switching data or
          from other organisations, like Opensignal and Ofcom (that’s the
          regulator for telecoms in the UK) to crown the right winners.
        </CardText>

        <CardText>
          <div sx={{ fontStyle: 'italic' }}>
            Analysis derived from Opensignal Awards - UK: Mobile Network
            Experience reports, April and September 2023, based on independent
            analysis during the period Dec 1 2022 - Feb 28, 2023 and Jun 1 to
            Aug 29, 2023.© 2024 Opensignal Limited.
          </div>
        </CardText>
      </div>
    )
  }
]

const Card = ({ icon, title, content }) => (
  <div
    sx={{
      background: '#242424',
      p: ['24px', '24px 24px 48px 24px'],
      mr: [0, 0, 16],
      mb: [16, 16, 0],
      borderRadius: 8,
      maxWidth: ['100%', '100%', 550],
      flex: 1
    }}
  >
    <span sx={{ display: 'flex', alignItems: 'center', mb: 18 }}>
      {icon}
      <h5 sx={{ ml: 16, mb: 0, lineHeight: '32px', fontSize: [18, 28] }}>
        {title}
      </h5>
    </span>
    {content}
  </div>
)

const DecidingWinners = () => (
  <div
    sx={{
      color: '#F5F5F5'
    }}
  >
    <Container>
      <h2
        sx={{
          textAlign: 'center',
          fontSize: ['36px', '42px'],
          pt: [48, 64], // use padding to prevent margin collapse
          pb: [32, 48],
          m: 0
        }}
      >
        Deciding the winners
      </h2>
      <div
        className="animate__animated animate__fadeIn"
        sx={{
          display: 'flex',
          flexDirection: ['column', 'column', 'row'],
          justifyContent: 'center'
        }}
      >
        {content.map(({ icon, title, content }) => (
          <Card key={title} icon={icon} title={title} content={content} />
        ))}
      </div>
    </Container>
  </div>
)

export default DecidingWinners
